import Techbridge3 from "../../../assets/Techbridge-3.jpg";
import Techbridge4 from "../../../assets/Techbridge-4.jpg";
import Techbridge5 from "../../../assets/Techbridge-5.jpg";
import Techbridge6 from "../../../assets/Techbridge-6.jpg";
import Techbridge7 from "../../../assets/Techbridge-7.jpg";

const services = [
  {
    num: '01',
    icon: 'ri-cpu-line',
    title: 'IT Hardware',
    description: 'Reliable hardware solutions selected around your business requirements.',
    capabilities: ['Sales', 'Service', 'Upgrades'],
    image: Techbridge3,
  },
  {
    num: '02',
    icon: 'ri-router-line',
    title: 'Networking',
    description: 'Reliable network infrastructure that keeps your teams and systems connected.',
    capabilities: ['Setup', 'Configuration', 'Support'],
    image: Techbridge4,
  },
  {
    num: '03',
    icon: 'ri-computer-line',
    title: 'Laptop & Desktop',
    description: 'Complete computer solutions from purchase and setup to maintenance.',
    capabilities: ['Sales', 'Service', 'Maintenance'],
    image: Techbridge5,
  },
  {
    num: '04',
    icon: 'ri-printer-line',
    title: 'Printers & Xerox',
    description: 'Dependable printing solutions for everyday business operations.',
    capabilities: ['Sales', 'Installation', 'Service'],
    image: Techbridge6,
  },
  {
    num: '05',
    icon: 'ri-tools-line',
    title: 'AMC & IT Support',
    description: 'Ongoing maintenance and technical assistance to keep your IT running.',
    capabilities: ['Maintenance', 'Troubleshooting', 'Support'],
    image: Techbridge7,
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-site mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-20 animate-on-scroll">
          <span className="font-label text-xs uppercase tracking-[0.2em] text-foreground-500">Services</span>
          <h2 className="mt-4 font-heading text-[36px] md:text-[48px] font-bold text-foreground-950 tracking-[-0.02em] leading-[1.12]">
            One partner.<br />Every IT need.
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-[560px] mx-auto">
            Everything your business needs to build, maintain and support a reliable IT environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {services.slice(0, 3).map((service, i) => (
            <ServiceCard key={service.num} service={service} index={i} />
          ))}
        </div>

        <div className="mt-4 md:mt-5 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {services.slice(3, 5).map((service, i) => (
            <ServiceCard key={service.num} service={service} index={i + 3} wide />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, index, wide }: { service: typeof services[0]; index: number; wide?: boolean }) {
  return (
    <div
      className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden transition-all duration-300 cursor-default animate-on-scroll hover:border-primary-500 hover:-translate-y-1 hover:shadow-lg hover:shadow-primary-500/5"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="relative h-[200px] overflow-hidden">
        <img
          src={service.image}
          alt={service.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
      </div>
      <div className="p-6 md:p-8">
        <div className="flex items-start justify-between mb-5">
          <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl flex items-center justify-center bg-primary-50 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
            <i className={`${service.icon} text-primary-500 group-hover:text-white text-xl transition-colors duration-300`}></i>
          </div>
          <span className="font-heading text-sm font-bold text-primary-500/30 group-hover:text-primary-500/60 transition-colors duration-300">{service.num}</span>
        </div>

        <h3 className="font-heading text-xl md:text-[22px] font-bold text-foreground-950 mb-2">{service.title}</h3>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">{service.description}</p>

        <div className="flex flex-wrap gap-2 mb-5">
          {service.capabilities.map((cap) => (
            <span key={cap} className="font-label text-[11px] font-medium text-foreground-600 bg-background-100 rounded-md px-2.5 py-1 whitespace-nowrap group-hover:bg-primary-50 group-hover:text-primary-700 transition-colors duration-300">
              {cap}
            </span>
          ))}
        </div>

        <div className="flex items-center gap-2 text-sm font-semibold text-primary-500 group-hover:gap-3 transition-all duration-200">
          <span className="font-label text-xs">Learn more</span>
          <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
        </div>
      </div>
    </div>
  );
}